import { apiService } from "../../../../services/api";
import { Candidate } from "../../../../types";

export const formApi = {
    getCandidateProfile: async (): Promise<Candidate> => {
        console.log('Fetching candidate profile');
        const response = await apiService.get('/candidate/profile'); 
        return response.data;
    },
    
    apply: async (jobId: string, data: any): Promise<any> => {
        console.log('Submitting application for job:', jobId);
        const response = await apiService.post(`/applications/jobs/${jobId}/apply`, data);
        return response.data;
    }
};